import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

// Components
import { Chip } from '@mui/material'
import Autocomplete from '../Autocomplete'

// Services
import useCards from '../../../hooks/cards/useCards'

const filters = {
    isExport: true
}

const AutocompleteCards = ({ multiple, value, getOptionValue, getOptionLabel, disabled, size, ...rest }) => {
    const { cards, loading } = useCards({ filters })
    const selected = useMemo(() => {
        if (!value || !cards || cards.length === 0) {
            return multiple ? [] : ''
        }

        if (multiple) {
            return Array.isArray(value)
                ? cards.filter(b => value && value.some(v => getOptionValue(b) === v))
                : [cards.find(b => getOptionValue(b) === value)]
        }
        return cards.find(b => getOptionValue(b) === value)
    }, [multiple, cards, value, getOptionValue])

    const RenderTags = (value, getTagProps) =>
        value.map((option, index) => (
            <Chip
                size={size}
                key={getOptionValue(option)}
                label={getOptionLabel(option)}
                {...getTagProps({ index })}
            />
        ))

    return (
        <Autocomplete
            size={size}
            name='cards'
            label='Tarjeta'
            placeholder='Ej.: Visa'
            getOptionValue={getOptionValue}
            getOptionLabel={getOptionLabel}
            loadingText='Buscando tarjetas...'
            {...rest}
            multiple={multiple}
            value={selected}
            options={cards}
            disabled={loading || cards.length === 0 || disabled}
            data-testid='cards-autocomplete'
            renderTags={multiple && RenderTags}
        />
    )
}

AutocompleteCards.defaultProps = {
    getOptionValue: (option) => option?.id || '',
    getOptionLabel: (option) => option?.name || '',
    getOptionKey: (option) => option?.id || null,
    size: 'small'
}

AutocompleteCards.prototype = {
    getOptionValue: PropTypes.func,
    getOptionLabel: PropTypes.func
}

export default AutocompleteCards
